import React, {Component} from "react";
import {post} from './../../networking/Api';
import HeaderRight from "../layouts/HeaderRight";
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import helpers from './../../networking/Helpers';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import {Link} from "react-router-dom";
import CheckinPopup from "../timeregistration/CheckinPopup";

const format = 'HH:mm';
var location='';

class FlexDetail extends Component {
    constructor(props) {
      super(props);
      var neweDate=new Date().toISOString();
      neweDate=neweDate.split("T");
  
     this.state={
     	users:[],
     	user_details:[],
         user_id : (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid'),
         details:[],
         absence_types:[],
         schemalist:[],
         start_date:'',
         end_date:'',
         dipartmentId:'',
         date_range:'',

        meetTime:'',
        leaveTime:'',
        total_time:'00:00',
        date:'',
        timestamp_id:'',
          
        timestamp_details:[],
          
        expireOpen:false,
        showPayment: false,
      
        show_datefilter:false,
        selectedDate: neweDate[0],
        previous_sign : '',
        previous_hour : '',
        previous_minute : '',

        is_flex: 0,
        flexData:[],
        weekDays: [],
        workScheduleDetails: [],
        mondays: [],
        isFlexTime: false,
        from_0 : '', from_1:'', from_2:'',from_3:'',from_4:'',from_5:'',from_6:'',
        to_0 : '',to_1 : '',to_2 : '',to_3 : '',to_4 : '',to_5 : '',to_6 : '',

      	meeting_date:'',
        meeting_time:'',
        leaving_date:'',
        leaving_time:'',
      	note:'',
      	checkInStatus:true,
      	enable_next_button : true,
        emp_edit:1,
        flex_addedit_schema : 1,
        flex_see_schema : 1,
        total_count : -1,
        grand_total_sign : '',
        timeStampOption:[],
        total_flex_report_list : -1,
        deposit_pay_list:[],
        flex_report_list:[],
    }

        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.showPosition)
        } else {
          console.log("Geo Location not supported by browser");
        }
    }

  //function that retrieves the position
  showPosition(position) {
    location = {
      longitude: position.coords.longitude,
      latitude: position.coords.latitude
    }
  }
    componentDidMount(){
        let department_id= localStorage.getItem('department_id');
		    let timestamp_option= localStorage.getItem('timestamp_option');
		    let timesoption=JSON.parse(timestamp_option);
		    let startDate=timesoption.date_range.start_date;
		    let endDate=timesoption.date_range.end_date;
        
		    var str=startDate;
		    str= str.split(" - "); //convert 'jQuery' to array
		    str = str.reverse(); //reverse 'jQuery' order 
		    str = str.join(" - ");
		    var strs=endDate;
		    strs= strs.split(" - "); //convert 'jQuery' to array
		    strs = strs.reverse(); //reverse 'jQuery' order 
		    strs = strs.join(" - ");
		    this.setState({
              start_date:str,end_date:strs,
            });

        //this.getTimeStampList(department_id,startDate,endDate,'onpageload');
		    this.getFlexSchemaList();
		    if(timesoption.date_filter==="monthly"){
		        this.setState({date_range:30})
		    }
		    if(timesoption.date_filter==="weekly"){
		        this.setState({date_range:7})
		    }
		    this.setState({dipartmentId:department_id});

        if(localStorage.getItem('user_type') === 'user'){  
         this.setState({
            emp_edit:timesoption.flex_addedit_record,
            flex_addedit_schema:timesoption.flex_addedit_schema,
            flex_see_schema:timesoption.flex_see_schema
          });
        }
        if(localStorage.getItem('user_type') === 'guest'){  
         this.setState({
            emp_edit:timesoption.guest_setting.emp_edit,
            flex_addedit_schema:timesoption.guest_setting.emp_edit,
            flex_see_schema:timesoption.guest_setting.emp_edit
          });
        }

  	}

  getFlexSchemaList(){
      var formData=new FormData();
      var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
      formData.append("user_id",userID);
      post(Constent.FLEXTPREVIOUSSCHEMALIST,formData).then(response=>{
          if(response.status===1){
            console.log(response.data);
            this.setState({
                schemalist:response.data,
                user_details:response.user_details,
                schema_count: response.count
            })
            if(response.count > 0 ){
              var startDate = response.data[0]['start_date'];
              var endDate = response.data[0]['end_date'];
              let department_id = localStorage.getItem('department_id');
              this.getTimeStampList(department_id,startDate,endDate,'search');
            }else{
                 this.setState({ total_count:response.count});
            	//Alert.success({title: response.message});
            }
          }
      })
  }

  getTimeStampList(id,start,end,type="search"){
       var formData=new FormData();
       var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
       formData.append("user_id",userID);
       formData.append("department_id",id);
       formData.append("start_date",start);
       formData.append("end_date",end);
       formData.append("type",type);
       post(Constent.FLEXTIMEUSER,formData).then(response=>{
            if(response.status===1){
            this.setState({
                users:response.data,
                total_count:response.data.length,
                details:response.details,
                grand_total_sign: ((response.details['grand_total']).substring(0,1)),
                absence_types:response.absence_types,
                start_date: response.start_date,
                is_flex: response.is_flex
            })
          }
      })
  }


  handleDateChange = date => {
    var neweDate=date.toISOString();
    neweDate=neweDate.split("T");
    this.setState({ start_date: neweDate[0] });
  };
  handleDateChange1 = date => {
    var neweDate=date.toISOString();
    neweDate=neweDate.split("T");
    this.setState({ end_date: neweDate[0] });
  };
  handleSearch=()=>{
    let department_id= localStorage.getItem('department_id');
    let startDate=this.state.start_date;
    let endDate=this.state.end_date;
    let type='search';
    this.getTimeStampList(department_id,startDate,endDate,type);   
  }
  handleChange (event, date, start, end) {
    	let selected_absence = event.target.value;
      var formData=new FormData();
      var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
      formData.append("user_id",userID);
      formData.append("absence_id",selected_absence);
      formData.append("date",date);
      formData.append("schema_starttime",start);
      formData.append("schema_endtime",end);
      post(Constent.FLEXSETABSENCE,formData).then(response=>{
          if(response.status===1){
            this.handleSearch();
            Alert.success({title: response.message});
          }else{
          	Alert.error({title: response.message});
          }
      })
  }

  getTimeStampDetail = (date) => {
    var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');

    var formData=new FormData();
    formData.append("user_id",userID);
    formData.append("selected_date",date);
    post(Constent.GetTimeStampDetail,formData).then(response=>{
        if( response.status===1 ){
	          var data=response.data;
	          this.setState({
	              timestamp_details:data,
	              date:date,
	          })
	          window['modalOpen']('#timedetails-modal');
        	}else{
        			window['modalClose']('#timedetails-modal');
        			Alert.error({title: response.message});
        	}
			  	this.getTimeStampList(userID,this.state.start_date,this.state.end_date,"search");
      })
  }

  handleExpireOpen = () => {
    this.setState({ expireOpen: true });
  };

  handleExpireClose = () => {
     this.setState({ expireOpen: false });
  };

  handleShowPayment = () => {
    this.setState({ showPayment: true });
  }

  startdt=()=>{
    var str=this.state.start_date;
    str= str.split("-"); //convert 'jQuery' to array
    str = str.reverse(); //reverse 'jQuery' order 
    str = str.join("/");
    return str;
  }

  enddt=()=>{
    var str=this.state.end_date;
    str= str.split("-"); //convert 'jQuery' to array
    str = str.reverse(); //reverse 'jQuery' order 
    str = str.join("/");
    return str;
  } 
  
  handledelet = () => {
    var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
    var formData=new FormData();
    formData.append("user_id",userID);
    formData.append("timestamp_detail_id",this.state.timestamp_detail_id);
    post(Constent.DELETIMESTAMEDETAIL,formData).then(response=>{ 
       if(response.status===1){
         	Alert.success({title: response.msg});
          this.getTimeStampDetail(this.state.date);
        }else{
        	Alert.error({title: response.msg});
        }
    })
  };

  addTimestamp = () => {
    var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
    var meeting_date= this.state.meeting_date;
        meeting_date= meeting_date.split("-"); //convert 'jQuery' to array
        meeting_date = meeting_date.reverse(); //reverse 'jQuery' order 
        meeting_date = meeting_date.join("-");  

    var startDateTime = meeting_date + ' ' + this.state.meeting_time,
        endDateTime = meeting_date + ' ' + this.state.leaving_time;
        startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
        endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
        if (endDateTime.isBefore(startDateTime)) {
            endDateTime = endDateTime.add(1, "days");
        }
    var leaving_date = moment(endDateTime).format('DD-MM-YYYY'); 

   var formData=new FormData();
   formData.append("latitude",location.latitude);
   formData.append("longitude",location.longitude);
   formData.append("meeting_date",meeting_date);
   formData.append("meeting_time",this.state.meeting_time);
   formData.append("leaving_date",leaving_date);
   formData.append("leaving_time", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
   formData.append("note",this.state.note);
   formData.append("user_id",userID);
   formData.append("deviceType","mobile manually");
   formData.append("selected_date",this.state.meeting_date);
   post(Constent.ADDTIMESTAMP,formData).then(response=>{
      if(response.flag===1){
          window['modalClose']();
          Alert.success({title: response.msg});
       this.getTimeStampDetail(this.state.date);
       }else{
         Alert.error({title: response.msg});
       }
   })
 };

    updateTimestamp = () => {
    	  var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
        var meeting_date= this.state.meeting_date;
        meeting_date= meeting_date.split("-"); //convert 'jQuery' to array
        meeting_date = meeting_date.reverse(); //reverse 'jQuery' order 
        meeting_date = meeting_date.join("-");  

    var startDateTime = meeting_date + ' ' + this.state.meeting_time,
        endDateTime = meeting_date + ' ' + this.state.leaving_time;
        startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
        endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
        if (endDateTime.isBefore(startDateTime)) {
            endDateTime = endDateTime.add(1, "days");
        }
    var leaving_date = moment(endDateTime).format('DD-MM-YYYY');   


        var formData=new FormData();
           formData.append("timestamp_detail_id", this.state.timestamp_detail_id);
           formData.append("meeting_date",meeting_date);
           formData.append("meeting_time",this.state.meeting_time);
           formData.append("leaving_date",leaving_date);
           formData.append("leaving_time", (this.state.leaving_time === '00:00' ? '' : this.state.leaving_time ));
           formData.append("note",this.state.note);
           formData.append("user_id",userID);
           formData.append("date",this.state.meeting_date);
           
       post(Constent.EDITTIMESTAMP,formData).then(response=>{
            window['modalClose']();
            if(response.status===1){
                Alert.success({title: response.msg});
                this.getTimeStampDetail(this.state.date);
            }else{
                Alert.error({title: response.msg});
           }
       })
     };
 
buildOptions(max) {
    var arr = [];
    for (let i = 0; i <= max; i++) {
       i = i > 9 ? i : "0" + i;
        arr.push(<option key={i} value={i} >{i}</option>)
    }
    return arr; 
  }

  selectedOptions(time,position,currentState) {
        time=time.split(":");
        time=time[position];
    return time; 
  }


 getSchema() {
    var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
    var formData=new FormData();
    formData.append("user_id", userID);
    post(Constent.GETFLEXSCHEMA,formData).then(response=>{
        if(response.status===1){
          var weekdetails = response.data.workScheduleDetails;    
          var flexData = response.data.flexData;
          this.setState({flexData: response.data.flexData,
                  previous_sign: flexData['sign'],
                  previous_hour: flexData['previous_hour'], 
                  previous_minute: flexData['previous_minute'],
                  
                  is_flex:response.data.is_flex,
                  weekDays:response.data.weekDays,
                  workScheduleDetails:response.data.workScheduleDetails,
                  mondays: response.data.mondays,
                  selectedDate : helpers.isEmpty(weekdetails[0]) ? '' : weekdetails[0].schedule_date,
                  total_week_hour : helpers.isEmpty(weekdetails[0]) ? '' : weekdetails[0].total_hours,
                  from_0 : helpers.isEmpty(weekdetails[0]) ? '' : weekdetails[0].from,
                  from_1 : helpers.isEmpty(weekdetails[1]) ? '' : weekdetails[1].from,
                  from_2 : helpers.isEmpty(weekdetails[2]) ? '' : weekdetails[2].from,
                  from_3 : helpers.isEmpty(weekdetails[3]) ? '' : weekdetails[3].from,
                  from_4 : helpers.isEmpty(weekdetails[4]) ? '' : weekdetails[4].from,
                  from_5 : helpers.isEmpty(weekdetails[5]) ? '' : weekdetails[5].from,
                  from_6 : helpers.isEmpty(weekdetails[6]) ? '' : weekdetails[6].from,
                  to_0 : helpers.isEmpty(weekdetails[0]) ? '' : weekdetails[0].to,
                  to_1 : helpers.isEmpty(weekdetails[1]) ? '' : weekdetails[1].to,
                  to_2 : helpers.isEmpty(weekdetails[2]) ? '' : weekdetails[2].to,
                  to_3 : helpers.isEmpty(weekdetails[3]) ? '' : weekdetails[3].to,
                  to_4 : helpers.isEmpty(weekdetails[4]) ? '' : weekdetails[4].to,
                  to_5 : helpers.isEmpty(weekdetails[5]) ? '' : weekdetails[5].to,
                  to_6 : helpers.isEmpty(weekdetails[6]) ? '' : weekdetails[6].to,
                });
                 window['modalOpen']('#schema-modal');
        }else{
        	Alert.error({title: response.msg});
        }
    })
 }
   
  handleDateChange2 = e => {
    this.setState({ selectedDate: e.target.value });
  };
  handlePreviousSalary = e => {
    this.setState({previous_sign : e.target.value})
  }
  handleSaveSchema = () => {
   var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
   var formData=new FormData();
   formData.append("user_id", userID);
   formData.append("total_hours",this.state.total_week_hour);
   formData.append("schedule_date",this.state.selectedDate);
   formData.append("from[0]",this.state.from_0);
   formData.append("to[0]",this.state.to_0);
   formData.append("from[1]",this.state.from_1);
   formData.append("to[1]",this.state.to_1);
   formData.append("from[2]",this.state.from_2);
   formData.append("to[2]",this.state.to_2);
   formData.append("from[3]",this.state.from_3);
   formData.append("to[3]",this.state.to_3);
   formData.append("from[4]",this.state.from_4);
   formData.append("to[4]",this.state.to_4);
   formData.append("from[5]",this.state.from_5);
   formData.append("to[5]",this.state.to_5);
   formData.append("from[6]",this.state.from_6);
   formData.append("to[6]",this.state.to_6);
   formData.append("previous_sign",this.state.previous_sign);
   formData.append("previous_hour",this.state.previous_hour);
   formData.append("previous_minute",this.state.previous_minute);
   post(Constent.UPDATEFLEXSCHEMA,formData).then(response=>{
      if(response.flag===1){
          window['modalClose']('#schema-modal');
         	Alert.success({title: response.msg});
        }else{
        	 Alert.error({title: response.msg});
       }
   })
 };  

  getDuration = (meet, leave) => {
    if( (leave !== '00:00') && (leave !== '') ){
    var newDt=this.state.date.trim().split("-");
    //var sldat=newDt[1].toString().trimLeft()
    var meetDate = newDt[1]+"-"+newDt[2]+"-"+newDt[3].trim();
   
     var startDateTime = meetDate + ' ' + meet,
          endDateTime = meetDate + ' ' + leave;
        
        startDateTime = moment(startDateTime, 'DD-MM-YYYY HH:mm');
        endDateTime = moment(endDateTime, 'DD-MM-YYYY HH:mm');
        if (endDateTime.isBefore(startDateTime)) {
            endDateTime = endDateTime.add(1, "days");
        }
        //var duration = endDateTime.diff(startDateTime, "hours");
        //var newLeaveDate = moment(endDateTime).format('DD-MM-YYYY');
        
        // start added by srb - for hour and milute also
        var hourDiff = endDateTime - startDateTime; //in ms
        //var secDiff = hourDiff / 1000; //in s
        var minDiff = hourDiff / 60 / 1000; //in minutes
        var hDiff = hourDiff / 3600 / 1000; //in hours
        var humanReadable = {};
        humanReadable.hours = Math.floor(hDiff);
        humanReadable.minutes = minDiff - 60 * humanReadable.hours;
        var diffTime =  humanReadable.hours + ':' + humanReadable.minutes;
        //console.log(humanReadable); //{hours: 0, minutes: 30}
        this.setState({total_time:diffTime});
      }else{  
        this.setState({total_time:'00:00'});
      }
    };
  from_0TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ from_0: time });
  };
  to_0TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ to_0: time });
  };
  from_1TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ from_1: time });
  };
  to_1TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ to_1: time });
  };
  from_2TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ from_2: time });
  };
  
  to_2TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ to_2: time });
  };
  from_3TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ from_3: time });
  };
  to_3TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ to_3: time });
  };
  from_4TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ from_4: time });
  };
  to_4TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ to_4: time });
  };
  from_5TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ from_5: time });
  };
  to_5TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ to_5: time });
  };
  from_6TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ from_6: time });
  };
  to_6TimeChange = date => {
    var time = moment(date).format(format);
    this.setState({ to_6: time });
  };

  handleChangeSchema=(event)=>{
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    var startdate =  optionElement.getAttribute('startdate');
    var enddate   =  optionElement.getAttribute('enddate');
    let department_id = localStorage.getItem('department_id');
    this.getTimeStampList(department_id,startdate,enddate,'search');
  }

  hhandleDateFilterCange = () => event => {
    this.setState({ show_datefilter: event.target.checked });
  }

  getFlexReportSummery = () => {
        this.setState({
            user_id : this.state.user_id,
            total_flex_report_list : -1,
            flex_report_list:[],
            deposit_pay_list:[],
            timeStampOption:[]});
        var department_id= localStorage.getItem('department_id');
        var formData = new FormData();
        formData.append("department_id",department_id);
        formData.append("user_id",this.state.user_id);
        post(Constent.FLEXREPORTSUMMERY,formData).then(response=>{
          if(response.status){
            this.setState({
                flex_report_list:response.data,
                total_flex_report_list:response.data.length,
                deposit_pay_list:response.flex_schema,
                timeStampOption:response.timeStampOption,
            });
          }else{
            Alert.error({title: response.message});
          }
        })
    }

    changeCheckIn = (checkInStatus) => {
        this.setState({checkInStatus: checkInStatus});
    }
    render() {
        const { t } = this.props;
	    	return (
	    		 <>
	    			{/* Header Starts */}

                <div className="header-area timeregistraionpage" style={{'borderRadius': 0}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-3">
                                <Link className="menu-back-page home-clicked" to={'/'}>
                                    <i className="fa fa-home" />
                                </Link>
                            </div>
                            <div className="col-sm-6 col-6 text-center">
                                <div className="page-name">{t('lang.flex_sc_flex_details')}</div>
                            </div>
                            <div className="col-sm-3 col-3 text-right">
                               <HeaderRight />
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" mg-top-50 sub-header" style={{'padding':12}}>
                        
                        <div className="row action-row">
                            <div className="col-6 text-overflow">
                                <span className="name">{this.state.user_details!== '' ? this.state.user_details.full_name : '' }</span>
                            </div>
                            <div className="col-6">
                                <span className="previous"
                                onClick={() => {
                                  this.setState({end_date:this.state.start_date});    
                                  var date1 = new Date(this.state.start_date);
                                    date1.setDate(date1.getDate()-this.state.date_range);
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({start_date:neweDate[0]});
                                    this.getTimeStampList(this.state.user_id,neweDate[0],this.state.start_date);
                                    }}>{t('lang.filter_text_prev')}</span>
                                {this.state.enable_next_button === true ?
                                <span className="next"
                                    onClick={() => {
                                    var date1 = new Date(this.state.end_date);
                                    date1.setDate(date1.getDate() + this.state.date_range)
                                    var neweDate=date1.toISOString();
                                    neweDate=neweDate.split("T");
                                    this.setState({end_date:neweDate[0]});
                                    this.getTimeStampList(this.state.user_id,this.state.end_date,neweDate[0]);
                                    }}>{t('lang.filter_text_next')}</span>
                                    : ''}
                            </div>
                        </div>
                        <div className="row action-row">
                            <div className="col-6">
                                {(localStorage.getItem('user_type') !== 'user') ?
                                <div>
                                    <div className="group">{this.state.user_details!== '' ? this.state.user_details.group_name : '' } {this.state.user_details!== '' ? this.state.user_details.job_title : '' }</div>
                                </div> : '' }
                            </div>
                            <div className="col-6">
                                {(this.state.flex_see_schema === 1) ?
                                 <span className="btn-primary link" style={{color:'#ffffff'}} onClick={()=> { this.getSchema() }}><i className="las la-sliders-h"></i> {t('lang.flex_sc_schema')}</span>
                                 : '' }
                            </div>
                        </div>
                </div>

                <select className="form-control" onChange={this.handleChangeSchema} style={{ background: 'rgb(230, 230, 230)', padding: 0}} >
                  {this.state.schemalist.map(({ sno,start_date,end_date, schema_id}) => (
                  <option key={sno} value={schema_id} startdate={start_date} enddate={end_date}>{start_date} - {end_date}</option>
                  ))}
                </select>
                <div className="timeregistraion transaction-area pd-top-15 mg-bottom-40">
                        {this.state.total_count < 0 ? <div className="text-center">{t('lang.common_text_loading') }</div> : '' }
                        {this.state.total_count === 0 ? <div className="text-center">{t('lang.message__no_record_available')}</div> : '' }
                        {this.state.users.map(({ date, readDay, readDate, absence, dayDate, schemaStartTime,schemaEndTime,meetTime,leaveTime,color,breaks,totalWork, noteColumn, timestamp_id}) => (
                        
                        <div className="single-goal" key={date} >
                        <Link to={'#'}
                        onClick={()=> { 
		                  if(meetTime!=='' && leaveTime!==null){
		                    this.getTimeStampDetail(date)
		                  }else{
	                      if( helpers.isIntegrationExpired(localStorage.getItem('integration_id'))){
	                        this.handleExpireOpen();
	                      }else{
	                        this.setState({
	                        		date:date,
                                      meeting_date:date,
                                      meeting_time:'',
                                      leaving_time:'',
                                      note:'',
                                      timestamp_detail_id: ''})
                                    if(this.state.emp_edit === 1){
                                      window['modalOpen']('#add-timestamp-modal');
                                    }else{
                                      Alert.warning({title: 'Permission denied'});
                                    }
					            } 
						                    
						    }}} >
                            <div className="row">
                                <div className="col-6 pr-0">
                                    <div className="details">
                                        <h6>{readDay}</h6>
                                        <p>{readDate.replaceAll('-','/')}</p>
                                        <small> {t('lang.flex_sc_schema')} : 
                                        {schemaStartTime.length > 0 ? 
                                        	schemaStartTime +' - '+ schemaEndTime : '-'}
                                        </small>
                                    </div>
                                </div>
                                <div className="col-6 text-right">
                                    <div className="details">
                                    <div>
                                    	<p>
                                    	{meetTime.length > 0 ? 
                                        	meetTime +' - '+ leaveTime : ''}</p>
                                    </div>
                                
                                    <p className="hours">
                                        { breaks !== '00:00'  ? <i className="fa fa-coffee" aria-hidden="true" title={breaks}></i> : ''}

                                        { noteColumn.length > 0 ? <i className="fa fa-sticky-note-o" aria-hidden="true" title={noteColumn}></i>: ''}
                                        {t('lang.common_text_hours')} : <strong style={{color:(color)}} >{ totalWork !== '' ?  totalWork : '00:00'}</strong>  </p>
                                    </div>  
                                </div>
                            </div>
                            </Link>
                        </div>
                        ))}
                </div>
                {/* transaction End */}

                {/* Footer start */}
            <div className="footer-area">
                <div className="container">
                    <div className="footer-bottom text-center">
                        <div className="row center">
                            <div className="col-10 text-center" data-toggle="modal" data-target="#summery-modal" 
                                onClick={()=>{this.getFlexReportSummery()}} 
                                ><h6 style={{color:'white'}}> {t('lang.flex_balance')}: <span className="link" style={{color: (this.state.grand_total_sign === '+' ? 'lime' : 'red'),fontSize:20}} > {this.state.details['grand_total']}</span></h6>
                            </div>
                            <div className="col-2">
                                {(localStorage.getItem('user_type') !== 'user') ?
                                    <Link className="home-clicked" to={'/flex-userlist'}>
                                        <i className="fa fa-reply" />
                                    </Link>
                                : 
                                    <Link className="home-clicked" to={'/'}>
                                        <i className="fa fa-home" />
                                    </Link>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer End */}

            {/* Check in popip end  */}
                <CheckinPopup setCheckInStatus = {this.changeCheckIn}  checkinoutScreen="time" p_userid={(localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid')}/>
            {/* Checkin popup end  */}

            {/* Timeregistration details modal  start  */}
            <div id="timedetails-modal" className="modal modal-top fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content" style={{'background':'#F5F5F5'}}>
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.flex_sc_stamp_of')} {moment(this.state.date,"YYYY-MM-DD").format("dddd DD/MM/YYYY")}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                            
                        </div>
                        <div className="modal-body" style={{'paddingRight':0,'paddingLeft':0}}>
                        { (this.state.timestamp_details.length > 0) ? 
                            <div className="row" style={{'marginRight': 0,'marginLeft': 0}}>
                                  <div className="col-2">
                                  </div>
                                  <div className="col-3">
                                    Meet 
                                  </div>
                                  <div className="col-3">
                                    Leave
                                  </div>
                                  <div className="col-4">
                                    Time
                                  </div>
                            </div>
                        : <div className="col-12 text-center">{t('lang.message__no_record_available')}</div> }      
                        {this.state.timestamp_details.map((item) =>   
                            <div className="single-goal" key={Math.random()} style={{'paddingTop': 9,'paddingBottom': 7}}>
                                <div className="row" style={{'marginRight': 0,'marginLeft': 0}}>
                                  <div className="col-2 center">
                                  {item.type !== 'break' ? 
                                    <i className="las la-clock time-icon bg-theme"></i>
                                    : <i className="las la-coffee break-icon"></i>}
                                  </div>
                                  
                                    <div className={ (item.type === 'break') ? 'col-8 mgTp13' : 'col-8'} >
                                        <div className="row">
                                            <div className="col-4" style={{'textDecoration': 'underline'}}>
                                                <Link to={'#'} 
                                                data-toggle="modal" data-target={item.type !== 'break' ? '#edit-timestamp-modal' : '#edit-break-modal'}
                                                onClick={()=>{
                                                  this.setState({
                                                    primary_key: item.id,
                                                    meeting_date:this.state.date,
                                                    meeting_time:item.meeting,
                                                    leaving_time:item.leaving,
                                                    note:item.note,
                                                    timestamp_detail_id: item.timestamp_detail_id
                                                    })
                                                }}>
                                                    {item.meeting} 
                                                </Link>
                                            </div>
                                            <div className="col-4 text-center" style={{'textDecoration': 'underline'}}
                                            data-target="#edit-timestamp-modal" >
                                                <Link to={'#'} 
                                                data-toggle="modal" data-target={item.type !== 'break' ? '#edit-timestamp-modal' : '#edit-break-modal'}
                                                onClick={()=>{
                                                  this.setState({
                                                    primary_key: item.id,
                                                    meeting_date:this.state.date,
                                                    meeting_time:item.meeting,
                                                    leaving_time:item.leaving,
                                                    note:item.note,
                                                    timestamp_detail_id: item.timestamp_detail_id})
                                                }}>
                                                { (item.leaving !== '') ? item.leaving : '--:--' }
                                                </Link>
                                            </div>
                                            <div className="col-4 text-center">
                                                <span className="color-green">{ item.total_ime }</span>
                                            </div>
                                            {item.type !== 'break' ? 
                                            <div className="col-12" style={{'marginTop': 7,'marginBottom': 7}}>
                                                <input type="text" value={item.note} placeholder={t('lang.flex_sc_the_note_here')} style={{width:'100%'}} readOnly={true}/>
                                            </div> : ''}
                                        </div>
                                    </div>
                                    <div className="col-2 center">
                                      { (this.state.emp_edit === 1) ?
                                        <i className="las la-times-circle clear-icon" 
                                        onClick={()=>{
                                          if( helpers.isIntegrationExpired(localStorage.getItem('integration_id'))){
                                            this.handleExpireOpen();
                                        }else{
                                            Alert.delete({
                                                position:'toast-top-full-width',
                                                message:t('lang.message_this_data_wont_be_retrievable_once_deleted_are_you_sure'),
                                                btn_yes:t('lang.btn_text_yes_do_it'),
                                                action: () =>{   
                                                        this.setState({ timestamp_detail_id:item.timestamp_detail_id,primary_key:item.id })
                                                    if(item.type !== 'break'){
                                                        this.handledelet();
                                                    }else{
                                                        this.handledeletBreak();
                                                    }
                                                }
                                            })
                                        }
                                        }}></i>
                                        :''}
                                  </div>  
                                </div>
                            </div>
                        )}    
                            <div className="form-group basic center footer-action">
                              { (this.state.emp_edit === 1) ?
                                <Link to={'#'} className="add-record-btn center" 
                                    data-toggle="modal" data-target="#add-timestamp-modal"
                                    onClick={()=>{
                                      this.setState({
                                        meeting_date:this.state.date,
                                        meeting_time:'',
                                        leaving_time:'',
                                        note:'',
                                        timestamp_detail_id: ''})
                                    }}
                                    >
                                    <i className="las la-plus"></i> {t('lang.common_text_add_record')}
                                </Link>
                                : ''}
                            </div>
                                
                        </div>
                    </div>
                </div>
              </div>  
            {/* Timeregistration details modal end  */}

            {/*  add-timestamp-modal start */}
            <div id="add-timestamp-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_add_timestamp')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.timestamp_sc_meeting_date')}</span>
                                <div className="input-group mb-4">
                                    <input type="date" className="form-control form-control-lg"
                                    value={this.state.meeting_date}
                                    max={helpers.getCurrentDate()} 
                                    onChange={e => { this.setState({meeting_date: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_note')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={this.state.note} 
                                    onChange={e => { this.setState({note: e.target.value})}} />
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.addTimestamp()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>


        {/*  edit-timestamp-modal start */}
            <div id="edit-timestamp-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.timestamp_sc_edit_timestamp')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.timestamp_sc_meeting_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.meeting_time} 
                                    onChange={e => { this.setState({meeting_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_leaving_time')}</span>
                                <div className="input-group mb-4">
                                    <input type="time" className="form-control form-control-lg"
                                    value={this.state.leaving_time} 
                                    onChange={e => { this.setState({leaving_time: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.timestamp_sc_note')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    value={this.state.note} 
                                    onChange={e => { this.setState({note: e.target.value})}} />
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                        { (this.state.emp_edit === 1) ? <>
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateTimestamp()}}>{t('lang.modal_btn_save')}</button>
                        </>  : ''}    
                        </div>
                    </div>
                </div>
            </div>

          {/*  work-schedule-modal start */}
            <div id="schema-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.flex_sc_work_schedule')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               	<span className="label">{t('lang.flex_sc_start_date')}</span>
		                        		<div className="input-group mb-4">
		                        			<select className="form-control form-control-lg"
		                        				value={this.state.selectedDate}
									            onChange={(e) => this.handleDateChange2(e)}>
									            <option value="">{t('lang.common_text_select')}</option>
									              {this.state.mondays.map( ({ key, value}) => (
									                <option key={key} value={key}>{value}</option>
									              ))}                    
									          </select>
		                        		</div>

		                        		<div className="row">
		                        			<div className="col-4">
		                        					<span className="label text-overflow">{t('lang.flex_sc_current_salary')}</span>
						                        		<div className="input-group mb-4">
						                        			<select className="form-control form-control-lg"
						                        			value={this.state.previous_sign}
													            onChange={(e) => this.handlePreviousSalary(e)}>
												              <option>{t('lang.common_text_select')}</option>
												              <option key="+" value="+" >+</option>
												              <option key="-" value="-" >-</option>                  
													        </select>
						                        		</div>
		                        			</div>
		                        			<div className="col-4 pl-0">
		                        				<span className="label">{t('lang.common_text_hour')}</span>
        		                                <div className="input-group mb-4">
        		                                    <input type="number" className="form-control form-control-lg" value={this.state.previous_hour} onChange={e => { this.setState({previous_hour: e.target.value})}} placeholder="HH"/>
        		                                </div>
		                        			</div>

		                        			<div className="col-4 pl-0">
		                        				<span className="label">{t('lang.common_text_minute')}</span>
        		                                <div className="input-group mb-4">
        		                                    <input type="number" className="form-control form-control-lg" value={this.state.previous_minute} onChange={e => { this.setState({previous_minute: e.target.value})}} placeholder="MM"/>
        		                                </div>
		                        			</div>
		                        		</div>

		                        		<span className="label">{t('lang.flex_sc_total_hour_per_week')}</span>
                                        <div className="input-group mb-4">
                                            <input type="text" className="form-control form-control-lg" value={this.state.total_week_hour} onChange={e => { this.setState({total_week_hour: e.target.value})}} placeholder={t('lang.common_text_ex') + ' 40:00'}/>
                                        </div>

                                <div className="row">
                                	<div className="col-4"></div>
                                	<div className="col-4">{t('lang.common_text_from')}</div>
                                	<div className="col-4">{t('lang.common_text_to')}</div>
                                </div>

                                <div className="row">
                                	<div className="col-4">{this.state.weekDays[0]}</div>
                                	<div className="col-4 pl-0">
                                	    <input type="time" className="form-control form-control-lg"
		                                    value={this.state.from_0} 
                  							onChange={e => { this.setState({from_0: e.target.value})}} />
		                              </div>
                                	<div className="col-4 pl-0">
                                		<input type="time" className="form-control form-control-lg"
                                        value={this.state.to_0 } 
                  						onChange={e => { this.setState({to_0: e.target.value})}} />
                                	</div>
                                </div>

                                <div className="row">
                                	<div className="col-4">{this.state.weekDays[1]}</div>
                                	<div className="col-4 pl-0">
                                	   <input type="time" className="form-control form-control-lg"
		                                    value={this.state.from_1} 
                  							onChange={e => { this.setState({from_1: e.target.value})}} />
		                              </div>
                                	<div className="col-4 pl-0">
                                		<input type="time" className="form-control form-control-lg"
                                        value={this.state.to_1} 
                  						onChange={e => { this.setState({to_1: e.target.value})}} />
                                	</div>
                                </div>

                                <div className="row">
                                	<div className="col-4">{this.state.weekDays[2]}</div>
                                	<div className="col-4 pl-0">
                                	    <input type="time" className="form-control form-control-lg"
		                                value={this.state.from_2} 
                  						onChange={e => { this.setState({from_2: e.target.value})}} />
		                              </div>
                                	<div className="col-4 pl-0">
                                		<input type="time" className="form-control form-control-lg"
                                        value={this.state.to_2} 
                  						onChange={e => { this.setState({to_2: e.target.value})}} />
                                	</div>
                                </div>

                				<div className="row">
                                	<div className="col-4">{this.state.weekDays[3]}</div>
                                	<div className="col-4 pl-0">
                                	      <input type="time" className="form-control form-control-lg"
		                                    value={this.state.from_3} 
                  							onChange={e => { this.setState({from_3: e.target.value})}} />
		                              </div>
                                	<div className="col-4 pl-0">
                                		<input type="time" className="form-control form-control-lg"
                                        value={ this.state.to_3} 
                  						onChange={e => { this.setState({to_3: e.target.value})}} />
                                	</div>
                                </div>

                                <div className="row">
                                	<div className="col-4">{this.state.weekDays[4]}</div>
                                	<div className="col-4 pl-0">
                                	    <input type="time" className="form-control form-control-lg"
		                                value={ this.state.from_4} 
                  						onChange={e => { this.setState({from_4: e.target.value})}} />
		                              </div>
                                	<div className="col-4 pl-0">
                                		<input type="time" className="form-control form-control-lg"
                                        value={ this.state.to_4} 
                  						onChange={e => { this.setState({to_4: e.target.value})}} />
                                	</div>
                                </div>
                               
                                <div className="row">
                                	<div className="col-4">{this.state.weekDays[5]}</div>
                                	<div className="col-4 pl-0">
                                	    <input type="time" className="form-control form-control-lg"
		                                    value={ this.state.from_5 } 
                  							onChange={e => { this.setState({from_5: e.target.value})}} />
		                              </div>
                                	<div className="col-4 pl-0">
                                		<input type="time" className="form-control form-control-lg"
                                        value={ this.state.to_5} 
                  						onChange={e => { this.setState({to_4: e.target.value})}} />
                                	</div>
                                </div>

                                <div className="row">
                                	<div className="col-4">{this.state.weekDays[6]}</div>
                                	<div className="col-4 pl-0">
                                	    <input type="time" className="form-control form-control-lg"
		                                value={ this.state.from_6} 
                  						onChange={e => { this.setState({from_6: e.target.value})}} />
		                              </div>
                                	<div className="col-4 pl-0">
                                		<input type="time" className="form-control form-control-lg"
                                        value={ this.state.to_6 } 
                  						onChange={e => { this.setState({to_6: e.target.value})}} />
                                	</div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                        { (this.state.flex_addedit_schema === 1) ? <>
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.handleSaveSchema()}}>{t('lang.modal_btn_save')}</button>
                          </>
                         : '' }   
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal  Summery  */}
                <div id="summery-modal" className="home-page modal modal-top fade">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title text-overflow">{t('lang.flex_report_of')} : {this.state.user_details!== '' ? this.state.user_details.full_name : '' }</h5>
                                <div className="modal-close" data-dismiss="modal">
                                    <i className="la la-times" />
                                </div>
                            </div>
                            <div className="modal-body" style={{paddingRight:0}}>
                            <div className="row" style={{width:'100%'}}>
                                <div className="col-3">
                                <b>{t('lang.filter_text_period')}</b>
                                </div>
                                <div className="col-3 text-center">
                                    <b>{t('lang.flex_sc_schema')}</b>
                                </div>
                                <div className="col-2 text-center">
                                    <b>{t('lang.timestamp_sc_time')}</b>
                                </div>
                                <div className="col-3 text-right">
                                    <b>{t('lang.common_text_total')}</b>
                                </div>
                                <div className="col-1">
                                </div>
                            </div>      
                            {this.state.total_flex_report_list < 0 ? <p className="text-center">{t('lang.common_text_loading') }</p> : '' }
                            <ul className="transaction-inner">
                            {this.state.deposit_pay_list.map(({ id,created_at, previous_hour, previous_minute,sign,note}) => (
                                <li key={id} >
                                    <div className="row" style={{width:'100%'}}>
                                        <div className="col-3" style={{padding:0}}>
                                            <small>{moment(created_at,"YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}
                                           </small>
                                        </div>
                                        <div className="col-3 text-center">
                                         
                                        </div>
                                        <div className="col-2 text-center">
                                          
                                        </div>
                                        <div className="col-3 text-right">
                                            <span style={{color:(sign === '+' ? 'green' : 'red')}}>{sign}{previous_hour}:{previous_minute}</span>
                                        </div>
                                        <div className="col-1" style={{padding:0}}> 
                                            <i className="las la-times-circle" style={{color:'red',fontSize:22}} 
                                            onClick={()=>{
                                                Alert.delete({
                                                    position:'toast-top-full-width',
                                                    message:t('lang.message_this_data_wont_be_retrievable_once_deleted_are_you_sure'),
                                                    btn_yes:t('lang.btn_text_yes_do_it'),
                                                    action: () =>{   
                                                        this.handledeletPayInOut(id);
                                                    }
                                                })
                                            
                                            }}></i>  
                                        </div>
                                    </div>
                                </li>
                            ))}

                            {this.state.flex_report_list.map(({ id,start_date, end_date, flex_assign,total_time,flex_total,sign,flex_color}) => (
                                <li key={id} >
                                    <div className="row" style={{width:'100%'}}>
                                        <div className="col-3" style={{padding:0}}>
                                            <small>{moment(start_date,"YYYY-MM-DD").format("DD/MM")} - 
                                            {moment(end_date,"YYYY-MM-DD").format("DD/MM YY")}
                                           </small>
                                        </div>
                                        <div className="col-3 text-center">
                                          {flex_assign}
                                        </div>
                                        <div className="col-2 text-center">
                                          {total_time}
                                        </div>
                                        <div className="col-3 text-right">
                                            <span style={{color:flex_color}}>{sign}{flex_total}</span>
                                        </div>
                                        <div className="col-1">
                                        </div>
                                    </div>
                                </li>
                            ))}
                                <li><hr/>
                                    <div className="row" style={{width:'100%'}}>
                                        <div className="col-5" style={{padding:0}}>
                                            <div><small>{t('lang.flex_salary_payment_date')}: {this.state.timeStampOption.start_of_payment}</small></div>
                                            <div><small>{t('lang.flex_salary_type')} : {this.state.timeStampOption.date_filter}</small></div>
                                        </div>
                                        <div className="col-7 text-right" style={{padding:0}}>
                                            <b>{t('lang.flex_balance')}: <span style={{color:(this.state.timeStampOption.balance_sign === '+' ? 'green' : 'red')}}>{this.state.timeStampOption.balance_sign}{this.state.timeStampOption.balance}</span></b>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal One start  */}   
	    		   </>      
	          
	    )}
	   	
}

export default withTranslation('common')(FlexDetail);